import React, { useMemo } from 'react';
import { Select } from 'antd';
import {
  filterBranchesByCompany,
  getReportBranchSelectCompanyCode,
} from '../helpers/reportBranches';

const ReportBranchSelect = ({
  allBranches,
  companyCode,
  needsCompanyPicker,
  draftAdminCompanyCode,
  adminCompanyCode,
  effectiveCompanyCode,
  value,
  onChange,
  loading = false,
  placeholder = 'Tüm Şubeler',
}) => {
  const resolvedCompanyCode = useMemo(() => {
    if (needsCompanyPicker !== undefined) {
      return getReportBranchSelectCompanyCode({
        needsCompanyPicker,
        draftAdminCompanyCode,
        adminCompanyCode,
        effectiveCompanyCode,
      });
    }
    return companyCode;
  }, [
    needsCompanyPicker,
    draftAdminCompanyCode,
    adminCompanyCode,
    effectiveCompanyCode,
    companyCode,
  ]);

  const branchOptions = useMemo(
    () => filterBranchesByCompany(allBranches, resolvedCompanyCode),
    [allBranches, resolvedCompanyCode]
  );

  const notFoundContent = loading
    ? 'Yükleniyor...'
    : (Array.isArray(allBranches) && allBranches.length > 0
      ? 'Bu şirket için şube bulunamadı'
      : 'Şube listesi yüklenemedi');

  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs text-slate-500">Şube</span>
      <Select
        value={value || undefined}
        onChange={(next) => onChange(next ?? null)}
        placeholder={placeholder}
        className="w-full"
        loading={loading}
        notFoundContent={notFoundContent}
        getPopupContainer={(trigger) => trigger?.parentElement || document.body}
      >
        {branchOptions.map((branch) => (
          <Select.Option key={branch.ID ?? branch.SubeKodu} value={branch.SubeKodu}>
            {branch.SubeAdi}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default ReportBranchSelect;
